import * as React from "react";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import { Button } from "reactstrap";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import useEnumData from "../../../utils/enums";
import {
  FormDatePicker,
  FormDateTimePicker,
  FormDropDownList,
  FormInput,
  FormTimePicker,
} from "../../../components/sys-form/FormComponents";
import {
  emailValidator,
  requiredValidator,
} from "../../../components/sys-form/FormValidators";
import alertify from "alertifyjs";

export const ParticipantForm = (props) => {
  const { t } = useTranslation();
  const { DATAYESNO } = useEnumData();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid) {
      alertify.error("");
      return;
    }
    var katiliM_DURUMU = values.katiliM_DURUMU;
    var email = values.email;
    delete values.katiliM_DURUMU;
    delete values.email;
    var additionalInfo = JSON.stringify(values);
    var data = {
      eK_BILGILER: additionalInfo,
      etkinliK_KATILIMCI_ID: props.eventParticipant.etkinliK_KATILIMCI_ID,
      katiliM_DURUMU: katiliM_DURUMU,
      email: email,
    };
    setLoading(true);
    ParticipantService.updateEventParticipant(data).then(() => {
      setLoading(false);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: "2%",
      }}
    >
      {loading && <LoadingPanel />}
      <Form
        onSubmitClick={handleSubmit}
        render={(formRenderProps) => (
          <div style={{ alignSelf: "center" }}>
            <FormElement style={{ width: 480 }}>
              <div style={{ width: 480, alignSelf: "center" }}>
                {t("first_enter_email")}
                <Field
                  name="email"
                  id="email"
                  label={t("email")}
                  component={FormInput}
                  validator={(value) => emailValidator(value, t)}
                />
              </div>
              <hr></hr>
              {props.data?.fields.map((field) => {
                if (field.alaN_TIPI === "TEXT") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      component={FormInput}
                      validator={(value) => requiredValidator(value, t)}
                    />
                  );
                }
                if (field.alaN_TIPI === "DROPDOWN") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      component={FormDropDownList}
                      data={props.data.options.filter(
                        (a) => a.alaN_KODU === field.alaN_KODU
                      )}
                      textField="seceneK_ADI"
                      valueField="seceneK_KODU"
                      validator={(value) => requiredValidator(value, t)}
                      value={formRenderProps.valueGetter(field.alaN_KODU)}
                      onChange={(e) => {
                        formRenderProps.onChange(field.alaN_KODU, {
                          value: e.value.seceneK_KODU,
                        });
                      }}
                    />
                  );
                }
                if (field.alaN_TIPI === "DATETIME") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      component={FormDateTimePicker}
                      validator={(value) => requiredValidator(value, t)}
                      value={formRenderProps.valueGetter(field.alaN_KODU)}
                    />
                  );
                }
                if (field.alaN_TIPI === "DATE") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      component={FormDatePicker}
                      validator={(value) => requiredValidator(value, t)}
                      value={formRenderProps.valueGetter(field.alaN_KODU)}
                    />
                  );
                }
                if (field.alaN_TIPI === "TIME") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      component={FormTimePicker}
                      validator={(value) => requiredValidator(value, t)}
                      value={formRenderProps.valueGetter(field.alaN_KODU)}
                    />
                  );
                }
                if (field.alaN_TIPI === "NUMBER") {
                  return (
                    <Field
                      name={field.alaN_KODU}
                      id={field.alaN_KODU}
                      label={field.alaN_ADI}
                      type="number"
                      component={FormInput}
                      validator={(value) => requiredValidator(value, t)}
                    />
                  );
                }
              })}
              <hr></hr>
              <Field
                name="katiliM_DURUMU"
                id="katiliM_DURUMU"
                label={t("participation_status")}
                component={FormDropDownList}
                data={DATAYESNO}
                textField="text"
                valueField="value"
                validator={(value) => requiredValidator(value, t)}
                value={formRenderProps.valueGetter("katiliM_DURUMU")}
                onChange={(e) => {
                  formRenderProps.onChange("katiliM_DURUMU", {
                    value: e.value.value,
                  });
                }}
              />
              <hr></hr>
              <Button disabled={loading} onClick={formRenderProps.onSubmit}>
                {loading ? t("saving") : t("save")}
              </Button>
            </FormElement>
          </div>
        )}
      />
    </div>
  );
};
